export const SITE_URL = 'https://www.pascal.finance';

/**
 * External destinations used by the calls to action. The design shipped with
 * placeholders; swap these for the real app and download URLs.
 */
export const links = {
  startFree: '#',
  download: '#',
  firmDemo: '#',
  securityEmail: 'security@pascal.finance',
};

export const SEO = {
  home: {
    path: '/',
    title: 'Pascal | AI-powered personal and business finance audit, cloud or desktop',
    desc: 'Pascal reads every bank statement you drop in, understands each transaction and keeps a double-entry ledger that always balances. Personal and business editions. Run it in the fully encrypted cloud or 100% local on your own computer.',
  },
  personal: {
    path: '/personal',
    title: 'Pascal Personal | Every account you have, one ledger that balances',
    desc: 'Import statements from every bank you use. Pascal understands each line, separates transfers, fees and income, and keeps the books double-entry. Fully encrypted cloud or 100% local desktop app.',
  },
  business: {
    path: '/business',
    title: 'Pascal Business | Multi-entity finance audit for owners and audit firms',
    desc: 'Run several companies or client workspaces from one audit tool. Vendor payments, internal transfers and expenses classified with confidence scores, approvals, audit trail and QuickBooks exports. Cloud or on-premise desktop.',
  },
  security: {
    path: '/security',
    title: 'Security | How Pascal keeps your ledger private',
    desc: 'What leaves your device and what never does. Fully encrypted cloud, 100% local desktop, and an AI model that only ever sees anonymised transaction descriptions, never balances, account numbers or files.',
  },
  docs: {
    path: '/docs',
    title: 'Docs | How to use Pascal',
    desc: 'Import statements, review what Pascal understood, link transfers, search in plain language and export to Excel or QuickBooks. Everything Pascal does, explained in order.',
  },
  changelog: {
    path: '/changelog',
    title: "Changelog | What's new in Pascal",
    desc: 'Release notes for Pascal Personal, Pascal Business and the desktop edition for macOS and Windows.',
  },
  notFound: {
    path: '/404',
    title: 'Page not found | Pascal',
    desc: 'The page you were looking for does not exist.',
  },
};

export const OG = {
  title: 'Pascal | Your accounts, finally legible',
  desc: 'AI-powered finance audit that reads your statements, understands every transaction and keeps a double-entry ledger that balances. Fully encrypted cloud or 100% local desktop.',
  image: `${SITE_URL}/og-image.png`,
  imageAlt: 'Pascal wordmark with the tagline: your accounts, finally legible',
};

export const JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Pascal',
  url: `${SITE_URL}/`,
  applicationCategory: 'FinanceApplication',
  operatingSystem: 'Web, macOS, Windows',
  description: 'AI-powered finance audit software that reads bank statements, understands every transaction and keeps a double-entry ledger that balances. Personal and business editions, fully encrypted cloud or 100% local desktop.',
  offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD', description: 'Free for one ledger' },
  publisher: { '@type': 'Organization', name: 'Pascal', url: `${SITE_URL}/`, logo: `${SITE_URL}/apple-touch-icon.png` },
};
